module.exports = __webpack_public_path__ + "static/img/xmzj.7ecbde70.png";